import React, { Component } from 'react';
import {Link} from "react-router-dom";
import MediaQuery from "react-responsive";

export default class OurStory extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section id="ourStory" className="contact-wrapper main-wrapper">
                <div className="container">
                    <div className="row">
                        <MediaQuery minWidth={777}>
                        <div
                            className="banner"
                            style={{ backgroundImage: `url("images/our-story/banner.png")`}}
                        ></div>
                        </MediaQuery>
                        <MediaQuery maxWidth={776}>
                            <div
                                className="banner"
                                style={{ backgroundImage: `url("images/our-story/banner-responsive.png")`}}
                            ></div>
                        </MediaQuery>
                        <div className="col-12 offset-md-2 col-md-8 text-center pt-4">
                            <h2 className="title text-dark-green pb-4">Our Story</h2>
                            <div className="text-justify">
                                <h4 className="font-size-16 text-black">How Freebird Club started</h4>
                                <p className="font-size-16 text-black">
                                    The story of the Freebird Club began in beautiful county Kerry, Ireland, when Peter Mangan started renting out his country cottage to visitors from around the world. While Peter was away working at a university in Dublin, his retired veterinarian father Owen was on hand to meet and greet the guests.
                                </p>
                                <p className="font-size-16 text-black">
                                    This was an enjoyable experience for Owen, but when fellow older adults came to stay, something special happened. There were nights together in the local pub, games of golf and local sightseeing trips, with Owen at the helm.
                                </p>
                                <p className="font-size-16 text-black">
                                    In essence, fun was being had and friendships were being formed that went way beyond the usual host/guest interaction. Seeing the enriching social benefits that his father was now enjoying prompted Peter to think how he could encapsulate and replicate this life-enhancing experience for the benefit of older adults everywhere.
                                </p>

                                <img src="/images/our-story/our-story.png" alt="Owen and his guests enjoying a local evening out" style={{ width: '100%'}}/>

                                <p className="font-size-16 text-black mt-2">
                                    Owen and his guests enjoying a local evening out
                                </p>

                                <h4 className="font-size-16 text-black">How we’ve grown</h4>
                                <p className="font-size-16 text-black">
                                    Following a successful pilot phase, the Freebird Club was officiall launched in 2017 as a social travel and homestay club exclusively for the over 50's. It is now developing as a global 'peer-to-peer'community, whereby Freebird Club members can connect, meet or stay with each other in the context of a social members' travel club. Members who wish to travel can search and connect with like-minded locals in estinations far and wide, knowning that a genuine, warm and personal welcome awaits them from a fellow Freebird Club member.
                                </p>
                                <p className="font-size-16 text-black">
                                    By creating a genuine community of travellers and hosts, based on the principles of the new 'sharing economy', the Freebird Club opens up a whole new world of social travelling for mature adults, a new way of generating income in later life, and a fun and accessible way to meet new people and enjoy social and cultural interaction as we grow older.
                                </p>
                            </div>
                            <div className="pt-2 pt-md-5">
                                <Link to='/signup' className="btn btn-block btn-join text-decoration-none py-2">
                                    Join club
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
};
